/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

module.exports = {
    HTTP_URL: 'http://a.tiles.mapbox.com/v4',
    HTTPS_URL: 'https://a.tiles.mapbox.com/v4',
    FORCE_HTTPS: false,
    REQUIRE_ACCESS_TOKEN: true
};




//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/config.js
// module id = 591
// module chunks = 49